import { inject, Injectable } from '@angular/core';
import { format } from 'date-fns';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SimpleConfigBaseFilter, SkeletonLoaderLayout } from 'gung-list';
import { Observable } from 'rxjs';
import { SchedulersListComponent } from '../../components/schedulers-list/schedulers-list.component';
import { SchedulerOverview } from '../../models/scheduler';
import { SchedulersOverviewService } from '../schedulers-overview/schedulers-overview.service';

@Injectable({
  providedIn: 'root'
})
export class SchedulersOverviewConfigService implements ConfigService<SchedulerOverview> {
  protected schedulersOverviewService = inject(SchedulersOverviewService);
  
  skeletonLoaderLayout: SkeletonLoaderLayout = 'table';
  topFilter: boolean = true;

  getItems(): Observable<SchedulerOverview[]> {
    return this.schedulersOverviewService.getSchedulers();
  }

  getFilters(): ConfigBaseFilter<SchedulerOverview>[] {
    return [new SchedulerStatusFilter(), new SchedulerDateFilter()];
  }

  getSortOptions(): ListSortOption<SchedulerOverview>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<SchedulerOverview>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SchedulersListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Scheduler list'
      }
    ];
  }
  
  getSearchTerms(item: SchedulerOverview): string[] {
    return [item.jobInstanceId, item.jobName];
  }

  getItemId(item: SchedulerOverview): string {
    return item.jobInstanceId;
  }
}

export class SchedulerStatusFilter extends SimpleConfigBaseFilter<SchedulerOverview> {
  getName(): string {
    return 'STATUS';
  }

  getOptionIds(item: SchedulerOverview): string[] {
    return [item.status];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class SchedulerDateFilter extends SimpleConfigBaseFilter<SchedulerOverview> {
  type = 'betweenDateTimeRangeFilter';

  getName(): string {
    return 'EXECUTION_DATE';
  }

  getOptionIds(item: SchedulerOverview): string[] {
    const result: string[] = [];
    const start = new Date(item.startTime);
    const end = new Date(item.endTime);
    const current = new Date(start);
  
    while (current <= end) {
      result.push(format(current, 'yyMMddHHmm'));
      current.setMinutes(current.getMinutes() + 1);
    }
  
    return result;  }

  getOptionName(key: string): string {
    return key;
  }
}